import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import TeamsForm from '../../components/Teams/TeamsForm';

const AddTeamsPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const navigate = useNavigate();
    const handleBackButton = () => {
        navigate(`/teams`);
    };
    const theme = useTheme();

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <TeamsForm />
            <CustomButton
                onClick={handleBackButton}
                color='primary'
                sx={{
                    marginLeft: !isMobile ? '-8px' : '-18px',
                    '&:hover': {
                        cursor: 'pointer',
                        color: theme.palette.textAccent.main,
                        backgroundColor: 'transparent',
                        background: 'none',
                    },
                }}
            >
                <ArrowBackIcon />{' '}
                <Typography
                    sx={{
                        fontSize: '12px',
                        paddingLeft: '5px',
                    }}
                >
                    Back to list
                </Typography>
            </CustomButton>
        </Grid>
    );
};

export default AddTeamsPage;
